// Configuración global de SweetAlert2
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

// Opciones globales para SweetAlert2
const options = {
  confirmButtonColor: '#0091CD',
  cancelButtonColor: '#6c757d',
  // Configuración por defecto para notificaciones tipo toast
  toast: {
    position: 'bottom-left',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
  }
}

// Registrar SweetAlert2 con las opciones globales
Vue.use(VueSweetalert2, options)

// Extender Vue con un método para mostrar notificaciones toast de forma consistente
Vue.prototype.$toast = {
  success: function (title) {
    Vue.prototype.$swal.fire({
      icon: 'success',
      title: title,
      toast: true,
      position: 'bottom-left',
      showConfirmButton: false,
      timer: 3000
    })
  },
  error: function (title) {
    Vue.prototype.$swal.fire({
      icon: 'error',
      title: title,
      toast: true,
      position: 'bottom-left',
      showConfirmButton: false,
      timer: 3000
    })
  },
  warning: function (title) {
    this.$swal.fire({
      icon: 'warning',
      title: title,
      toast: true,
      position: 'bottom-left',
      showConfirmButton: false,
      timer: 3000
    })
  }
}
